import { useCallback } from 'react';

import { ActionMeta } from 'react-select';

import { IClient } from 'types/api/client';
import { IClientProps } from 'types/components/client';
import { OnSelectedData } from 'types/components/common';

export const useOnChange = <AllowMultiple extends boolean = false>({
  onSelected,
}: Pick<IClientProps<AllowMultiple>, 'onSelected'>) => {
  return useCallback(
    (value: OnSelectedData<IClient, AllowMultiple>, actionMeta: ActionMeta<IClient>) => {
      onSelected?.(value, actionMeta);
    },
    [onSelected]
  );
};
